export const SERVICES = [
  {
    title: "Frontend development / engineering",
    content:
      "I plan, design, build, test and maintain scalable frontend web applications.",
  },
  {
    title: "Interaction design / animation",
    content:
      "I collaborate with designers to plan and execute interactions / animations on web applications and design systems.",
  },
  {
    title: "Creative implementation",
    content:
      "I build layouts and interactions optimizing for performance and usabilty.",
  },
];
